import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between card-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Seller Request", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Status:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Reason:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Comment:", -1)
const _hoisted_6 = { style: {"white-space":"pre-line"} }
const _hoisted_7 = { class: "flex items-center justify-between card-header" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Customer", -1)
const _hoisted_9 = {
  class: "warning custom-block",
  style: {"font-size":"0.75rem"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Address 1: ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("b", null, "Address 2: ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "City: ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("b", null, "Province - Zip: ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Country Code: ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Phone: ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Email: ", -1)
const _hoisted_17 = {
  key: 2,
  class: "text-center",
  hidden: ""
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Mark as valid ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Addess invalid", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Addess valid", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Address verified by user", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Address is checking valid", -1)
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  style: {"vertical-align":"middle"},
  class: "font-bold"
}, " Mark as valid ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  style: {"vertical-align":"middle"},
  class: "font-bold"
}, " Check again ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Price")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Seller")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Agency note")
], -1)
const _hoisted_30 = { class: "mt-3" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Note")
], -1)
const _hoisted_33 = { class: "mt-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Comment")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", null, "This comment to share information to seller", -1)
const _hoisted_36 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_Finished = _resolveComponent("Finished")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_GrandTotalOrder = _resolveComponent("GrandTotalOrder")!
  const _component_OrderSellerTeamCard = _resolveComponent("OrderSellerTeamCard")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CustomerDialog = _resolveComponent("CustomerDialog")!
  const _component_RequestSellerDialog = _resolveComponent("RequestSellerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.state.order.requestSellerStatus)
        ? (_openBlock(), _createBlock(_component_el_card, {
            key: 0,
            class: "mb-3"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_component_el_link, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickRequestSeller(_ctx.state.order))),
                  title: "Edit Request Seller",
                  underline: false,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { style: {"font-size":"1.25rem"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Edit)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("p", null, [
                  _hoisted_3,
                  _createVNode(_component_el_tag, {
                    type: 
              _ctx.state.order.requestSellerStatus ===
              _ctx.RequestSellerStatusEnum.requested
                ? `warning`
                : `success`
            ,
                    size: "small",
                    title: _ctx.state.order.requestSellerStatus
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.state.order.requestSellerStatus), 1)
                    ]),
                    _: 1
                  }, 8, ["type", "title"])
                ]),
                _createElementVNode("p", null, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_ctx.state.order.requestSellerReasonCode), 1)
                ]),
                _createElementVNode("span", null, [
                  _hoisted_5,
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.state.order?.requestSellerComment), 1)
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_card, { class: "mb-3" }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_link, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalEditCustomer())),
              title: "Edit Customer",
              underline: false,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"font-size":"1.25rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Edit)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.state.order?.errorMsg)
            ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.showErrorMsg(_ctx.state.order.errorMsg)), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { class: "text-xl font-bold" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.state.order.fullName), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { class: "mt-3" }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.order.address1), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.state.order.address2)
                    ? (_openBlock(), _createBlock(_component_el_row, {
                        key: 0,
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11,
                          _createTextVNode(" " + _toDisplayString(_ctx.state.order.address2), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_row, { class: "mt-2" }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.order.city), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { class: "mt-2" }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.order.province) + " - " + _toDisplayString(_ctx.state.order.zipCode), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { class: "mt-2" }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.order.countryCode), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_row, { class: "mt-2" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _hoisted_15,
                        _createTextVNode(" " + _toDisplayString(_ctx.state.order.phone), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.state.order.email)
                    ? (_openBlock(), _createBlock(_component_el_row, {
                        key: 1,
                        class: "mt-2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.state.order.email), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.order.addressValid === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_el_divider, { direction: "horizontal" }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.verifyAddressOrder([_ctx.state.order._id])))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_18
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { class: "mt-5" }, {
            default: _withCtx(() => [
              (_ctx.state.order.addressValid === 0)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "info",
                    class: "w-full text-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.order.addressValid === 1)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "success",
                    class: "w-full text-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_20
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.order.addressValid === 2)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    type: "warning",
                    class: "w-full text-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.state.order.addressValid === 3)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 3,
                    type: "primary",
                    class: "w-full text-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_22
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_divider, { direction: "horizontal" }),
          _createElementVNode("div", _hoisted_23, [
            (
            _ctx.state.order.addressValid === 0 &&
            _ctx.validateOrderActionSeller(_ctx.state.order.status)
          )
              ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 0,
                  "confirm-button-text": "Yes",
                  "cancel-button-text": "No",
                  icon: _ctx.InfoFilled,
                  "icon-color": "#626AEF",
                  title: "Are you sure to Mark as valid this?",
                  width: "20%",
                  onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.verifyAddressOrder([_ctx.state.order._id])))
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Finished)
                          ]),
                          _: 1
                        }),
                        _hoisted_24
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["icon"]))
              : _createCommentVNode("", true),
            (
            (_ctx.state.order.addressValid === 0 ||
              _ctx.state.order.addressValid === 2) &&
            _ctx.validateOrderActionSeller(_ctx.state.order.status)
          )
              ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 1,
                  "confirm-button-text": "Yes",
                  "cancel-button-text": "No",
                  icon: _ctx.InfoFilled,
                  "icon-color": "#626AEF",
                  title: "Are you sure to Check Address valid again?",
                  onConfirm: _ctx.checkingAddress,
                  width: "20%"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }),
                        _hoisted_26
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["icon", "onConfirm"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      (_ctx.state.order?.grandTotal)
        ? (_openBlock(), _createBlock(_component_el_card, {
            key: 1,
            class: "mb-3"
          }, {
            header: _withCtx(() => [
              _hoisted_27
            ]),
            default: _withCtx(() => [
              _createVNode(_component_GrandTotalOrder, {
                order: _ctx.props.state.order
              }, null, 8, ["order"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_card, { class: "mb-3" }, {
        header: _withCtx(() => [
          _hoisted_28
        ]),
        default: _withCtx(() => [
          (_ctx.props.state.order.sellerTeam)
            ? (_openBlock(), _createBlock(_component_OrderSellerTeamCard, {
                key: 0,
                sellerTeamId: _ctx.props.state.order.sellerTeam
              }, null, 8, ["sellerTeamId"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "my-3" }, {
        header: _withCtx(() => [
          _hoisted_29
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_30, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.props.state.order.agencyNote,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.props.state.order.agencyNote) = $event)),
                      autosize: { minRows: 6, maxRows: 10 },
                      type: "textarea",
                      placeholder: "..."
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 24,
                class: "mt-3",
                style: {"text-align":"end"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: _ctx.updateAgencyNote
                  }, {
                    default: _withCtx(() => [
                      _hoisted_31
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "my-3" }, {
        header: _withCtx(() => [
          _hoisted_32
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_33, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.props.state.order.note,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.props.state.order.note) = $event)),
                      autosize: { minRows: 2, maxRows: 4 },
                      type: "textarea",
                      placeholder: "Seller order note"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "my-3" }, {
        header: _withCtx(() => [
          _hoisted_34
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  _createElementVNode("span", _hoisted_36, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.props.state.order.comment,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.props.state.order.comment) = $event)),
                      autosize: { minRows: 2, maxRows: 4 },
                      type: "textarea",
                      placeholder: "Order comment"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (!_ctx.data.isLoading)
      ? (_openBlock(), _createBlock(_component_CustomerDialog, {
          key: 0,
          customer: _ctx.data.customer,
          ref: "customerDialog",
          onUpdateSuccess: _ctx.reset
        }, null, 8, ["customer", "onUpdateSuccess"]))
      : _createCommentVNode("", true),
    _createVNode(_component_RequestSellerDialog, {
      ref: "requestSellerDialog",
      onOnAfterResquestSeller: _ctx.onAfterResquestSeller
    }, null, 8, ["onOnAfterResquestSeller"])
  ], 64))
}